import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {AttributeManipulationGroupsApiService} from '../../../../services/api/settings/call-flow-configurations/attribute-manipulation-groups/attribute-manipulation-groups-api.service';
import _ from 'lodash';
import {RoleTypeEnum} from '../../../../services/enums/role-type.enum';

@AcDialog({
  width: 1100
})
@Component({
  selector: 'normalization-groups-dialog',
  templateUrl: './normalization-groups-dialog.component.html',
  styleUrls: ['./normalization-groups-dialog.component.scss']
})
export class NormalizationGroupsDialogComponent implements OnInit, AfterViewInit{

  isEditMode: boolean;
  group: any;
  isUnauthorized: boolean;

  @ViewChild('normalizationForm') normalizationForm: NgForm;
  canSubmit: boolean;
  testString: string;
  simulationResult: any;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private userPrivilege: UserPrivilegeService,
              private attributeManipulationGroupsApiService: AttributeManipulationGroupsApiService) {
    this.canSubmit = this.userPrivilege.isAuthorized(RoleTypeEnum.NORMALIZATION_GROUP);
    this.group = dialogConfig.dialogData.data;
    this.isEditMode = dialogConfig.dialogData.isEditMode;
    this.isUnauthorized = dialogConfig.dialogData.isUnauthorized;
    dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.normalizationForm.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.normalizationForm.form.valid || this.group.normalizationAttrs.length === 0;
    });
  }

  removeRule(index: number): void {
    this.group.normalizationAttrs.splice(index, 1);
  }

  moveUpRule(index: number): void {
    if (index === 0) { return; }

    this.swap(this.group.normalizationAttrs, index, index - 1);
    this.group.normalizationAttrs = _.cloneDeep(this.group.normalizationAttrs);
    this.updatePriority();
  }

  moveDownRule(index: number): void {
    if (index === this.group.normalizationAttrs.length - 1) { return; }

    this.swap(this.group.normalizationAttrs, index, index + 1);
    this.group.normalizationAttrs = _.cloneDeep(this.group.normalizationAttrs);
    this.updatePriority();
  }

  addRule(): void {
    if (this.group.normalizationAttrs.length === 0) {
      this.group.normalizationAttrs.push({
        priority: 1,
        regEx: '',
        replacement: '',
        index: 0
      });
    } else{
      const newRulePriority = this.group.normalizationAttrs[this.group.normalizationAttrs.length - 1].priority + 1;
      this.group.normalizationAttrs.push({
        priority: newRulePriority,
        regEx: '',
        replacement: '',
        index: this.group.normalizationAttrs.length
      });
    }

  }

  testNormalizationGroup(): void {
    const testRequest = {
      groupName: this.group.groupName,
      testString: this.testString,
      normalizationAttrs: this.group.normalizationAttrs
    };

    this.attributeManipulationGroupsApiService.testAttributeManipulationGroup(testRequest).subscribe(testResult => {
      for (let i = 0; i < testResult.results.length; i++) {
        this.group.normalizationAttrs[i].intermediateResult = testResult.results[i].result;
      }

      this.simulationResult = testResult.result;
    });
  }

  swap(array, from, to): void {
    const temp = array[from];
    array[from] = array[to];
    array[to] = temp;
  }

  private updatePriority(): void {
    this.group.normalizationAttrs.forEach((rule, index) => {
      rule.priority = ++ index;
    });
  }


}
